// Copyright (c) StrangeBee 2023

import { ReactElement } from 'react';
import { CaseOutput } from 'thehive-sdk';
import RouteBuilder from '@Services/RouteBuilder';
import { useLocalMessage } from '@Helpers/locale';
import { extractData } from './extractData';
import { ResultCard } from '../ResultCard';

import './CaseResultCard.scss';

interface CaseResultProps {
    data?: CaseOutput;
}

export const CaseResultCard = ({ data }: CaseResultProps): ReactElement => {
    const i = useLocalMessage();

    const {
        title = '',
        _createdAt = 0,
        tags = [],
        description = '',
        _id = '',
        assignee = '',
        startDate = 0,
        endDate = 0,
        extraData,
        number: caseNumber = 0,
        severity,
    } = data || {};

    return (
        <ResultCard
            data={{
                '#computeTitle': {
                    title,
                    path: RouteBuilder.compute('cases.details', { caseId: _id }),
                    caseNumber,
                    severity,
                },
                '#computeDate': {
                    date: _createdAt,
                    assignee,
                },
                '#computeStatus': {
                    status: extraData?.status,
                    startDate,
                    endDate,
                    _createdAt,
                },
                '#computeDescription': description,
                '#computeTags': tags,
            }}
            extract={extractData({ locale: i })}
        />
    );
};
